import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SingleBadge from '../SingleBadge/SingleBadge';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('TransitionSingleBadge');

const TransitionSingleBadge = memo((props) => {
    const { badge, stickyModifier, promoPriceApplied, className, ...rest } = props;
    const [displayModifier, setDisplayModifier] = useState('');
    const [displayBadge, setDisplayBadge] = useState(badge);
    const isSegmentedBadge = badge?.hasOwnProperty('sequence');

    useEffect(() => {
        if (isSegmentedBadge || promoPriceApplied) {
            setDisplayModifier('fadeOut');

            // Wait for fade-out to complete
            const timeout = setTimeout(() => {
                // Update the badge to be displayed after fade-out
                setDisplayBadge(badge);
                setDisplayModifier(promoPriceApplied ? 'hide' : 'fadeIn');
            }, 200); // This timing should match your CSS fade-out duration

            return () => clearTimeout(timeout);
        } else {
            setDisplayBadge(badge);
            setDisplayModifier(undefined);
        }
    }, [badge, isSegmentedBadge, promoPriceApplied]);

    return <SingleBadge {...rest} className={bem('transitionBadge', [displayModifier, stickyModifier], className)} badge={displayBadge} />;
});

TransitionSingleBadge.propTypes = {
    badge: PropTypes.object.isRequired,
    stickyModifier: PropTypes.string,
    promoPriceApplied: PropTypes.string,
    className: PropTypes.string,
};

TransitionSingleBadge.displayName = 'TransitionSingleBadge';

export default TransitionSingleBadge;
